import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
// Components
import Space, { Type } from '../layout/space';
import Text from '../text';
import TextCenterButton from '../buttons/textCenterButton';
import SvgIcon from '../icons/SvgIcon';
// Resources
import { IconAxel } from '../../resources/images';
import { stringsRes } from '../../resources/strings';
import { PropsFromModal } from './createModalHOC';

interface OnboardPaymentOption {
    title: string;
    description?: string;
}

const OnboardPayment: FC<PropsFromModal> = ({ onRequestClose }): ReactElement => {
    const classes = useStyle();

    const options: OnboardPaymentOption[] = [
        // {
        //     title: stringsRes.onboardPayment.contactlessTitle,
        //     description: stringsRes.onboardPayment.contactlessDescription,
        // },
        { title: stringsRes.onboardPayment.cashTitle },
        {
            title: stringsRes.onboardPayment.terminalTitle,
            description: stringsRes.onboardPayment.terminalDescription,
        },
    ];

    return (
        <div>
            <Text.Description14 text={stringsRes.onboardPayment.description} />

            <Space type={Type.vertical} value={3} />

            <div className={classes.optionsContainer}>
                {options.map(({ title, description }) => (
                    <div className={classes.optionContainer} key={title}>
                        <SvgIcon
                            icon={IconAxel.Check}
                            className={classes.icon}
                            color="blue"
                            fill="none"
                            overwritePathStroke
                        />
                        <div>
                            <Text.Description14 text={title} />
                            {description && <Text.Description14 text={description} customColor="grey" />}
                        </div>
                    </div>
                ))}
            </div>

            <div className={classes.buttonContainer}>
                <TextCenterButton
                    id="validateOnboardPayment"
                    title={stringsRes.onboardPayment.validate}
                    onClick={onRequestClose}
                />
            </div>
        </div>
    );
};

const useStyle = makeStyles((theme: Theme) =>
    createStyles({
        optionsContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
        },
        optionContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 16,
            borderRadius: 8,
            padding: 16,
            border: `1px solid ${theme.palette.colors.background.menuSeparator}`,
        },
        icon: {
            // variantBlue: #DAE2FB in light mode, and a dark surface in dark mode — where `blue`
            // resolves to the near-white icon colour, so the check stays legible on both.
            backgroundColor: theme.palette.colors.border,
            width: 26,
            height: 26,
            borderRadius: '50%',
            padding: 6,
            flexShrink: 0,
        },
        buttonContainer: {
            display: 'flex',
            marginTop: theme.spacing(3),
            flexDirection: 'column',
            justifyContent: 'center',
        },
    }),
);

export default OnboardPayment;
